import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/**
 * Body of R5: `multipart/form-data` with a single file field named `chunk`, no text field, no
 * digest — the digest is computed server-side on the bytes it actually receives (D-E).
 */
class TransferRecordingSegment {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly interviewId: number,
		public readonly recordingId: number,
		public readonly position: number,
		public readonly chunk: Blob,
	) {
		Object.freeze(this);
	}

	toFormData(): FormData {
		const formData = new FormData();
		formData.append('chunk', this.chunk);

		return formData;
	}
}

export default TransferRecordingSegment;
